import React, { useEffect } from "react";
import { Link, useLocation } from "react-router-dom";
import $ from 'jquery';
import MetaTags from 'react-meta-tags';

function Teaching01() {
	let location = useLocation();
	useEffect(() => {
		$(".qa_cell .qb_q").click(function () {
			if ($(this).parent().hasClass("active")) {
				$(this).siblings('.qb_a').slideToggle();
				$(this).parent().removeClass("active");
			} else {
				$(this).siblings('.qb_a').slideToggle();
				$(this).parent().addClass("active");
			}
		});
	}, [location])

	return (
		<div className="content_inpage">
			<MetaTags>
				<title>中華電信i寶貝智慧音箱-教學&QA</title>
				<meta name="keywords" content="i寶貝教學&QA,教學,使用i寶貝,教學手冊,QA,i寶貝有問題,常見問題,問題"></meta>
				<meta name="description" content="中華電信i寶貝智慧音箱與中華電信i寶貝智慧聲控服務內容一直不斷推層出新，依據新推出功能提供教學手冊。同時也彙整常見問題，並提供智慧音箱與語音聲控相關疑難排解。常見問題與Q&A包含:智慧音箱操錯、綁訂、語音聲控之熱門常見問題，簡單輸入文字即可搜尋，快速獲得解答。" />
				<meta property="og:title" content="中華電信i寶貝智慧音箱-教學&QA" />
				<meta property="og:Description" content="中華電信i寶貝智慧音箱與中華電信i寶貝智慧聲控服務內容一直不斷推層出新，依據新推出功能提供教學手冊。同時也彙整常見問題，並提供智慧音箱與語音聲控相關疑難排解。常見問題與Q&A包含:智慧音箱操錯、綁訂、語音聲控之熱門常見問題，簡單輸入文字即可搜尋，快速獲得解答。" />
				<meta property="og:image" content="https://ibobby.ai.hinet.net/app_icons/app_banner/imgUpload_496bf11d-5c35-41c7-b18c-894e7331f961.png" />
			</MetaTags>
			<div className="pagesize">
				<ul className="bread">
					<li><a href="/">首頁</a></li>
					<li><a href="/container/teaching">教學&QA</a></li>
				</ul>
				<div id="tab_con">
					<div className="tab_box active">
						<h2 className="tit_main">Q&A</h2>
						<div className="content_box qa_box">
							<div className="qa_cell">
								<div className="qb_q">請問「ｉ寶貝智慧聲控服務」於114年6月30日下架及停止服務後，原本購買的智慧音箱還能繼續使用嗎？</div>
								<div className="qb_a">智慧音箱可以當作藍芽喇叭繼續使用，其他功能則全部停止服務。</div>
							</div>
							<div className="qa_cell">
								<div className="qb_q">請問「ｉ寶貝智慧聲控服務」將於114年6月30日起下架及停止服務，服務可以使用到什麼時候？</div>
								<div className="qb_a">透過i寶貝APP訂閱「ｉ寶貝智慧聲控服務」的客戶，相關訂單將會於114年5月31日前取消，服務可以使用到最後一個計費周期為止。搭配本公司「寬頻網路、行動電話、MOD」資費方案訂購「ｉ寶貝智慧聲控服務」的客戶，ｉ寶貝服務可以使用到114年6月30日止。（註：本公司保留最終帳務調整權力）</div>
							</div>
							<div className="qa_cell">
								<div className="qb_q">請問「ｉ寶貝智慧聲控服務」將於114年6月30日起下架及停止服務，帳單會如何調整？</div>
								<div className="qb_a">透過i寶貝APP訂閱「ｉ寶貝智慧聲控服務」的客戶，相關訂單將會於114年5月31日前取消。「智慧家庭聲控包」的客戶，帳單將調整為僅出帳MOD聲控助理的月租費$25元。「i寶貝聲控服務+KKBOX音樂超值包」綁約一年的客戶，綁約期間出帳KKBOX月租費$129，合約期滿後KKBOX月租費恢復牌價$149。「i寶貝聲控服務+KKBOX音樂超值包」綁約兩年（含）以上的客戶，綁約期間出帳KKBOX月租費$100，合約期滿後KKBOX月租費恢復牌價$149。（註：本公司保留最終帳務調整權力）</div>
							</div>
							<div className="qa_cell">
								<div className="qb_q">什麼是i寶貝智慧聲控服務？主要功能為何？</div>
								<div className="qb_a">i寶貝是中華電信研發的AI智慧語音應用平台，整合了語音辨識、通訊連網、人工智慧、大數據等介面。主要功能有: MOD聲控、中華個人助理、中華智慧家庭、KKBOX、hichannel廣播、FunPark有聲書、大家說英語、股市行情、HiNet生活誌新聞、1288查詢店家、愛播聽書有聲書等等，未來不斷推出及開發更多更新的智慧應用服務。</div>
							</div>
							<div className="qa_cell">
								<div className="qb_q">i寶貝智慧音箱是什麼？</div>
								<div className="qb_a">符合指定規格的聲控喇叭搭載i寶貝智慧聲控服務，即可使用『中文聲控』給音箱下指令，是AI人工智慧音箱，亦是藍牙音箱。</div>
							</div>
							<div className="qa_cell">
								<div className="qb_q">i寶貝智慧音箱的適用對象？</div>
								<div className="qb_a">i寶貝智慧音箱提供多元服務，忙碌上班族開口就能獲得交通、新聞資訊，科技癮父母播放童書、英文陪小孩子一起成長，樂活銀髮族由智慧音箱隨時提醒代辦事項，慵懶沙發族只要動口輕鬆轉台MOD、聽音樂，積極投資族說出股票馬上掌握財金資訊，適合全年齡層用戶。</div>
							</div>
							<div className="qa_cell">
								<div className="qb_q">如何申購i寶貝智慧音箱？有任何限制嗎?</div>
								<div className="qb_a">中華電信全省門市/神腦特約服務中心(行動4G方案)均可購買，可以搭配優惠方案聰明小錢就可以享受智慧聲控，另有單機方案輕鬆把音箱帶回家！詳細方案內容請看官網的「優惠方案」。</div>
							</div>
							<div className="qa_cell">
								<div className="qb_q">使用i寶貝智慧音箱服務網路環境及手機版本建議?</div>
								<div className="qb_a">建議網路頻寬至少20M以上，具備Wifi或行動4G熱點分享功能，且頻段為2.4Ghz的Wi-Fi。手機版本iOS 10以上或 android 6.0以上。</div>
							</div>
							<div className="qa_cell">
								<div className="qb_q">綁約期滿後，我還可以使用聲控服務嗎?</div>
								<div className="qb_a">只要持續租用i寶貝智慧聲控服務，即可持續聲控智慧音箱及收聽i寶貝上各種內容。</div>
							</div>
							<div className="qa_cell">
								<div className="qb_q">申購i寶貝智慧音箱後，何時可以使用？</div>
								<div className="qb_a">
									請參閱並執行以下四步驟，就可以喚醒i寶貝開始享受您的智慧生活。<br />
									(1) 將i寶貝智慧音箱插上電源。<br />
									(2) 下載i寶貝+ APP並登入中華電信會員帳號。<br />
									(3) 使用i寶貝+ APP設定智慧音箱並連上網。<br />
									(4) 驗證並啟用i寶貝智慧語音助理服務。
								</div>
							</div>
							<div className="qa_cell">
								<div className="qb_q">i寶貝智慧音箱有保固維修嗎?需要維修費嗎?</div>
								<div className="qb_a">i寶貝智慧音箱享有一年保固期，客戶可以攜帶音箱至中華電信門市或神腦門市維修，一年內非人為因素故障維修免維修費，其餘損壞依損壞情形報價維修。</div>
							</div>
							<div className="qa_cell">
								<div className="qb_q">i寶貝智慧音箱韌體版本升級是否會通知?</div>
								<div className="qb_a">請在手機開啟i寶貝APP通知權限，每當音箱版本可以升級時，APP會發出通知給使用者。</div>
							</div>
							<div className="qa_cell">
								<div className="qb_q">如何申請中華電信會員登入i寶貝+APP？</div>
								<div className="qb_a">您可上網免費註冊中華電信會員帳號（<a href="https://member.cht.com.tw/" target="_blank" className="btn_link" rel="noreferrer">https://member.cht.com.tw/</a> ）。</div>
							</div>
							<div className="qa_cell">
								<div className="qb_q">如何下載i寶貝+APP？</div>
								<div className="qb_a">
									至「Google Play」或「App Store」搜尋i寶貝+或ibobby，也可以至<Link as={Link} to={"/"} className="btn_link">官網首頁</Link>
									下方掃描二維條碼直接下載，方便又快速。
								</div>
							</div>
							<div className="qa_cell">
								<div className="qb_q">i寶貝智慧音箱如何安裝及設定音箱？燈號代表什麼意思?</div>
								<div className="qb_a">
									歡迎請至<Link to={"/container/teaching/Teaching0201"} className="btn_link">官網-安裝教學</Link>
									依照步驟設定，或依循APP安裝指引即可。下方也有音箱按鍵功能說明、音箱燈號說明提供參閱。
									<a href={require("../../pdf/CHT_MS2806_QSG_20190409.pdf").default} target="_blank" className="btn_link" rel="noreferrer">MS2806</a>
									和<a href={require("../../pdf/CHT_A02_QSG_20190409.pdf").default} target="_blank" className="btn_link" rel="noreferrer">A02</a>
									也提供兩款音箱電子版使用手冊下載。
								</div>
							</div>
							<div className="qa_cell">
								<div className="qb_q">如果使用i寶貝智慧音箱過程中聽到”網路無法連線”如何處理？</div>
								<div className="qb_a">當i寶貝智慧音箱回應「網路無法連線」，可能是家中wifi訊號不佳，通常是音箱與家中wifi AP距離太遠或是在不同房間中，建議將音箱放置在家中wifi AP附近。</div>
							</div>
							<div className="qa_cell">
								<div className="qb_q">手機APP設定啟用後，如何開始使用i寶貝智慧音箱服務？</div>
								<div className="qb_a">在租用i寶貝服務，並於APP完成設備綁定啟用後，可於APP中選擇基本內容服務啟用。即可喚醒i寶貝智慧音箱下達指令，範例：『i寶貝』，請告訴我今天台北的天氣?</div>
							</div>
							<div className="qa_cell">
								<div className="qb_q">i寶貝智慧音箱 是否支持多隻手機下載i寶貝App，共同使用音箱?</div>
								<div className="qb_a">目前本服務透過中華電信會員綁定，同一帳號僅能綁定一台設備，用戶如需在另一支手機使用，需登入相同的會員帳號。如果要更換綁定的手機，請先執行i寶貝app裡的「移除此設備」後再進行綁定。</div>
							</div>
							<div className="qa_cell">
								<div className="qb_q">i寶貝智慧音箱如何進行智慧家庭MOD的配對?配對失敗?</div>
								<div className="qb_a">於i寶貝APP的「技能開通」啟用MOD服務，依照APP指示取得MOD多螢服務設定配對碼(用戶預設密碼為1234)，在APP上面輸入，即可完成MOD串連，開始聲控MOD。若配對失敗，請查詢MOD多螢設備是否有大於2個設備上限。</div>
							</div>
							<div className="qa_cell">
								<div className="qb_q">i寶貝智慧音箱若無法使用時，要如何進行障礙排除?</div>
								<div className="qb_a">
									Step 1.請參閱使用手冊上的障礙排除方式<br />
									Step 2.檢查i寶貝App，音箱是否被解除綁定。<br />
									Step 3.如持續無法恢復正常使用，請聯絡客服人員(0800-080-123)，並提供App中設備MAC序號資訊，以利平台人員查測。<img src={require("../../image/img_qa_setting.jpg").default} alt="img_qa_setting" style={{ margin: "20px auto 0 auto" }}></img>
								</div>
							</div>
							<div className="qa_cell">
								<div className="qb_q">LUCIA智慧音箱一定要放上手機才能使用嗎?</div>
								<div className="qb_a">不用喔! 與其他智慧音箱一樣，LUCIA智慧音箱在WiFi 連線狀態並完成註冊 i 寶貝語音平台即可獨立運作。</div>
							</div>
							<div className="qa_cell">
								<div className="qb_q">第一次使用如何設定LUCIA智慧音箱？</div>
								<div className="qb_a">LUCIA 智慧音箱隨貨內附「快速安裝指南」，請依照指南，先掃描QR code，下載安裝「i寶貝 APP」、「bIOS LUCIA APP」，依照指示即可開始設定Lucia智慧音箱。</div>
							</div>
							<div className="qa_cell">
								<div className="qb_q">請問為什麼需要安裝兩個APP (bIOS LUCIA App &amp; i寶貝APP)?</div>
								<div className="qb_a">LUCIA智慧音箱之智能語音採用中華電信i寶貝語音平台，使用者必須下載i寶貝APP將音箱聯網並開通語音服務。而bIOS LUCIA APP則是主要是用來體驗視覺化語音互動、控制情境呼吸燈。</div>
							</div>
							<div className="qa_cell">
								<div className="qb_q">請問LUCIA有藍芽功能可以連線嗎?</div>
								<div className="qb_a">請先將您的LUCIA智慧音箱更新韌體至 IBI8_B28310以上版本，即可透過語音喚醒來開啟藍芽。Ex:打開/關閉藍芽。</div>
							</div>
							<div className="qa_cell">
								<div className="qb_q">如何查詢i寶貝智慧音箱物流進度?</div>
								<div className="qb_a">凡寬頻綁約申辦或單機購買i寶貝智慧音箱用戶，如音箱尚未送達可至下列網址查詢物流進度。註：若同時申辦MOD或是更新MOD機型，需待MOD施工完成後音箱才會開始配送。 <a href="https://ibcsw.cht.com.tw/maintain/ibobby-logistics-utf.html" target="_blank" className="btn_link" rel="noreferrer">設備物流查詢作業</a></div>
							</div>
							<div className="qa_cell">
								<div className="qb_q">如何匯入Panasonic綁定的家電?</div>
								<div className="qb_a">
									請參閱並執行以下兩步驟，若不清楚請參閱
									<Link to={"/container/teaching/Teaching0202"} className="btn_link">「安裝及教學」</Link>。<br />
									(1)請先安裝Panasonic Smart APP，並註冊帳號與綁定設備。<br />
									(2)在i寶貝+ APP 「新增設備」處選擇匯入Panasonic設備，輸入帳號後即可綁定。
								</div>
							</div>
							<div className="qa_cell">
								<div className="qb_q">如何綁定i寶車?</div>
								<div className="qb_a">
									參閱並執行以下兩步驟的說明，即可享受便捷的i寶車服務 (音箱聲控詢問代步車位置、電量及接收告警通知)。<br />
									(1)請先安裝「千里馬APP」，並完成智能電動代步車綁定。<br />
									(2)開啟i寶貝+ APP，依據「音箱圖示&gt;音箱管理&gt;技能開通&gt;i寶車(千里馬)」，點選+號開啟掃描框進行千里馬代步車的QR code掃描，並選定代步車暱稱後儲存，
									即可完成配對，若不清楚請參閱<Link to={"/container/teaching/Teaching0203"} className="btn_link">「安裝及教學」</Link>。
								</div>
							</div>
							<div className="qa_cell">
								<div className="qb_q">如果沒有足夠的Hami Point點數進行聲控兌品，要如何取得更多點數?</div>
								<div className="qb_a">可使用LINE Points、OPEN POINT、PChome P幣，或其他點數進行轉換。<a href="https://hamipoint.cht.com.tw/transpoint" className="btn_link">「線上點數轉換」</a></div>
							</div>
							<div className="qa_cell">
								<div className="qb_q">請問購買i寶貝的權利義務有些哪？</div>
								<div className="qb_a">請參閱<a href={require("../../pdf/service_contract.pdf").default} className="btn_link" target="_blank" rel="noreferrer">「i寶貝智慧聲控(ibobby)服務租用契約條款_20220411.pdf」</a></div>
							</div>
							<div className="qa_cell">
								<div className="qb_q">請問要如何退租i寶貝聲控服務？</div>
								<div className="qb_a">當您不再使用i寶貝時，請透過APP的服務開通-&gt;寶貝智慧聲控服務-&gt;退租，辦理退租。此後i寶貝將不再提供聲控服務，您可視需求由「i寶貝智慧聲控服務」再次申租。(※如您的聲控服務是於中華電信/神腦門市申租，則請您至門市辦理退租，謝謝)。</div>
							</div>
						</div>
					</div>
				</div>
			</div>
		</div>
	)
}

export default Teaching01;